export default __webpack_public_path__ + "static/media/Q20.5a8ca5ad.jpg";